export enum ChangeOperation {
    Insert = "Insert",
    Update = "Update",
    Delete = "Delete"
}

export enum ChangeType {
    Stop = "Stop",
    Order = "Order"
}